import { Component, OnInit } from "@angular/core";
import { DesignKind, DesignService } from "@app/core/services/design.service";
import { Observable } from "rxjs";

@Component({
  selector: "app-auth-layout",
  templateUrl: "./auth-layout.component.html",
  styleUrls: ["./auth-layout.component.scss"],
})
export class AuthLayoutComponent implements OnInit {
  protected readonly design$: Observable<DesignKind>;

  constructor(private designService: DesignService) {
    this.design$ = designService.design$;
  }

  ngOnInit() {}

  protected switchToClassicDesign() {
    if (this.designService.getDesign() === "classic") {
      this.designService.setDesign("modern");
    } else {
      this.designService.setDesign("classic");
    }
  }
}
